export default {
  cardName: 'Name on Card',
  plan: 'Get my plan',
  continue: 'Continue',
}
